var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoblox2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3962 25.0002L10.3416 33.0039L18.3452 35.0586L20.3998 27.0549L12.3962 25.0002ZM15.9441 31.009L14.3792 30.6028L14.7854 29.0379L16.3503 29.4441L15.9441 31.009Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39953 25.8962C8.49004 25.8962 9.40989 27.1386 9.40989 28.369C9.40989 29.1335 9.07536 29.7786 8.46613 30.1967C9.35012 31.2002 9.89973 32.5739 10.067 34.1508H6.26814C6.11284 31.9527 5.64699 31.0926 4.65549 31.0926V34.1508H1V25.8843H6.39953V25.8962ZM4.65549 29.1933H4.751C5.41997 29.1933 5.7426 28.9543 5.7426 28.4168C5.7426 28.0584 5.5633 27.5925 4.88239 27.5925H4.65549V29.1933Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4208 25.8961C29.0966 25.8961 29.6223 27.2459 29.6223 28.2016C29.6223 28.8825 29.3834 29.5037 28.5472 29.9815C29.5864 30.531 29.8492 31.1642 29.8492 31.8809C29.8492 33.1591 28.9533 34.1626 27.0181 34.1626H21.2483V25.8961H26.4208ZM24.9156 29.1692H24.9993C25.7997 29.1692 26.0982 28.9422 26.0982 28.3569C26.0982 27.9029 25.8713 27.5565 25.1307 27.5565H24.9036V29.1692H24.9156ZM24.9156 32.3468H25.0231C25.8712 32.3468 26.1819 32.1198 26.1819 31.4986C26.1819 30.9611 25.9309 30.5669 25.1664 30.5669H24.9156V32.3468Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.972 25.8961H34.6274V32.084H37.8289V34.1626H30.9601V25.8961H30.972Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9519 25.8961V34.1626H47.2185V25.8961H38.9519ZM43.8855 30.8297H42.2729V29.217H43.8855V30.8297Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.21 25.8961H52.1998L53.4183 27.4132L54.5772 25.8961H58.5431L55.4133 29.9576L58.7462 34.1626H54.7443L53.4303 32.526L52.1641 34.1626H48.198L51.4235 29.9815L48.198 25.8961H48.21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoblox2);
export default __webpack_public_path__ + "static/media/roblox2.5f3b57ff7dd9050f2df9aec66788d151.svg";
export { ForwardRef as ReactComponent };